import { jsxs as i, jsx as t, Fragment as x } from "react/jsx-runtime";
import { Button as B } from "flowbite-react";
import { forwardRef as C } from "react";
import { Spinner as T } from "../Spinner/index.js";
import { Tooltip as n } from "../Tooltip/index.js";
import { buttonTheme as g } from "./theme.js";
const p = C(
  ({
    children: o,
    disabled: c,
    isProcessing: r,
    processingLabel: u,
    processingSpinner: a,
    size: e,
    tooltip: m,
    tooltipPlacement: l,
    ...d
  }, f) => {
    const h = r ? /* @__PURE__ */ i(x, { children: [
      a ?? /* @__PURE__ */ t(T, { size: e === "xs" ? "xs" : "sm" }),
      u ?? o
    ] }) : o, b = {
      ...d,
      size: e,
      disabled: c || r
    }, s = /* @__PURE__ */ t(B, { ...b, theme: g, ref: f, children: h });
    return m ? /* @__PURE__ */ i(n, { placement: l, children: [
      /* @__PURE__ */ t(n.Trigger, { asChild: !0, children: s }),
      /* @__PURE__ */ t(n.Content, { className: "tooltip-content-sm", children: m })
    ] }) : s;
  }
), $ = p;
p.displayName = "Button";
export {
  $ as Button
};
